<script setup lang="ts">
defineProps<{
  message: string
}>()

const emit = defineEmits<{
  close: []
}>()
</script>

<template>
  <div class="sk-banner" role="status">
    <p>{{ message }}</p>
    <button type="button" aria-label="关闭提示" @click="emit('close')">×</button>
  </div>
</template>

<style scoped>
.sk-banner {
  position: sticky;
  top: 4rem;
  z-index: 30;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin: 0;
  padding: 10px 16px;
  background: #fff8e8;
  color: #5c3b16;
  border-bottom: 1px solid #ead7a4;
  font-size: 14px;
  line-height: 1.5;
}
.sk-banner p {
  margin: 0;
}
.sk-banner button {
  border: 0;
  background: transparent;
  color: inherit;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
}
</style>
